var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoInsta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11.7 11.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#9ecb3a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ico insta") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8.1,0H3.6A3.61,3.61,0,0,0,0,3.61V8.1a3.6,3.6,0,0,0,3.6,3.6H8.1A3.6,3.6,0,0,0,11.7,8.1V3.61A3.61,3.61,0,0,0,8.1,0m2.48,7.66a2.91,2.91,0,0,1-2.91,2.91H4A2.91,2.91,0,0,1,1.12,7.66V4A2.91,2.91,0,0,1,4,1.12H7.66A2.91,2.91,0,0,1,10.58,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6,2.79A3.08,3.08,0,1,0,9.09,5.87,3.08,3.08,0,0,0,6,2.79M6,7.73A1.85,1.85,0,1,1,7.86,5.87,1.85,1.85,0,0,1,6,7.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M9.66,2.74A.78.78,0,1,1,8.88,2a.78.78,0,0,1,.78.78"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoInsta);
export default __webpack_public_path__ + "static/media/ico-insta.eb4e5a3210caae00317c6dec3cf797c9.svg";
export { ForwardRef as ReactComponent };